<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      direction="rtl"
      :size="1200"
      :show-close="false"
      @close="close(true)"
      :before-close="handleClose"
      append-to-body
    >
      <div slot="title" class="drawer-header-container">
        <div class="drawer-title-row">
          <span class="drawer-title">{{ $l('dialog_title_batch_update_fabric') || '批量更新面料' }}</span>
          <div>
            <el-button
              size="small"
              :disabled="!canSave"
              @click="save"
            >
              {{ $l('btn_confirm_update') || '确认更新' }}
            </el-button>
            <el-button class="mr-10px" size="small" @click="close(true)">{{ $l('btn_close') || '关闭' }}</el-button>
          </div>
        </div>
        
        <div class="drawer-content-container">
          <!-- 面料信息部分 -->
          <div class="section">
            <div class="section-header">
              <div class="section-title">
                {{ $l('form_label_fabric_info') || '面料信息' }}
                <el-button
                  type="primary"
                  size="small"
                  @click="openChooseFabric"
                  class="ml-2"
                >
                  {{ $l('btn_choose_fabric') || '选择面料' }}
                </el-button>
              </div>
            </div>
            <FabricInfo
              :tableData="fabricList"
              :tableHeight="340"
              @remove-fabric="removeFabric"
            />
          </div>

          <!-- 勾选需要更新面料的产品规格 -->
          <div class="section mt-3">
            <div class="section-header">
              <div class="section-title">{{ $l('form_label_select_product_spec') || '勾选需要更新面料的产品规格' }}</div>
            </div>
            <ProductSpec
              ref="productSpec"
              :tableData="productList"
              :tableHeight="290"
              @checkbox-change="handleProductChange"
            />
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 选择面料弹框 -->
    <el-dialog
      v-if="chooseFabricVisible"
      :title="$l('dialog_title_choose_fabric') || '选择面料'"
      :visible.sync="chooseFabricVisible"
      width="1200px"
      append-to-body
      :close-on-click-modal="false"
    >
      <ChooseFabric
        ref="chooseFabric"
        :tableHeight="450"
        @checkbox-change="handleFabricCheckboxChange"
        @confirm="confirmChooseFabric"
        @cancel="chooseFabricVisible = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import ChooseFabric from './chose-fabric'
import FabricInfo from './fabric-info'
import ProductSpec from './product-spec'
import EditLoading from '@/mixins/edit-loading'

export default {
  components: { ChooseFabric, FabricInfo, ProductSpec },
  props: {
    visible: { type: Boolean, default: false },
    checkedProducts: { type: Array, default: () => [] },
  },
  mixins: [EditLoading],
  data() {
    return {
      chooseFabricVisible: false,
      fabricList: [],
      productList: [],
      selectedProducts: [],
      selectedFabrics: [],
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.fabricList = []
          this.selectedFabrics = []
          this.getData()
        }
      },
      immediate: true,
    },
  },
  computed: {
    canSave() {
      return this.fabricList.length > 0 && this.selectedProducts.length > 0
    },
  },
  methods: {
    async getData() {
      const amzSkuCodeList = this.checkedProducts.map((item) => item.amzSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuSpecListApi({
          amzSkuCodeList,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.productList = (res.body && res.body.data) || []
      this.$nextTick(() => {
        if (this.$refs.productSpec && this.$refs.productSpec.$refs.table) {
          this.$refs.productSpec.$refs.table.setAllCheckboxRow(true)
          this.selectedProducts = this.$refs.productSpec.getSelectedProducts()
        }
      })
    },
    openChooseFabric() {
      this.chooseFabricVisible = true
      // 下一帧设置已选择的面料
      this.$nextTick(() => {
        if (this.$refs.chooseFabric) {
          this.$refs.chooseFabric.setSelectedFabrics(this.fabricList)
        }
      })
    },
    handleFabricCheckboxChange(fabrics) {
      this.selectedFabrics = fabrics
    },
    confirmChooseFabric() {
      if (this.selectedFabrics.length === 0) {
        this.$message({
          message: this.$l('tips_select_fabric') || '请选择面料',
          type: 'warning',
        })
        return
      }

      // 合并面料列表，已存在的面料保留原值，只添加新面料
      const existingFabricCodes = new Set(this.fabricList.map(f => f.fabricCode))
      const newFabrics = this.selectedFabrics
        .filter(fabric => !existingFabricCodes.has(fabric.fabricCode))
        .map((fabric) => ({
          ...fabric,
          id: fabric.fabricCode,
        }))
      this.fabricList = [...this.fabricList, ...newFabrics]

      this.chooseFabricVisible = false
    },
    removeFabric(index) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.fabricList.splice(index, 1)
        })
        .catch(() => {})
    },
    handleProductChange(products) {
      this.selectedProducts = products
    },
    async save() {
      // 验证面料位置是否都已填写
      const hasEmptyPosition = this.fabricList.some(
        (f) => !f.fabricPositionCode
      )
      if (hasEmptyPosition) {
        this.$message({
          message: this.$l('tips_fill_fabric_position') || '请填写所有面料的面料位置',
          type: 'warning',
        })
        return
      }

      // 准备保存数据
      const fabricData = this.fabricList.map((fabric) => ({
        fabricCode: fabric.fabricCode,
        fabricNo: fabric.fabricNo,
        fabricName: fabric.fabricName,
        fabricNameEn: fabric.fabricNameEn,
        fabricContent: fabric.fabricContent,
        fabricContentEn: fabric.fabricContentEn,
        fabricWeight: fabric.fabricWeight,
        fabricWeightUnit: fabric.fabricWeightUnit,
        yarnCount: fabric.yarnCount,
        density: fabric.density,
        wid: fabric.wid,
        widUnit: fabric.widUnit,
        defaultImageUrl: fabric.defaultImageUrl,
        defaultImageCode: fabric.defaultImageCode,
        fabricPositionCode: fabric.fabricPositionCode,
        fabricPositionName: fabric.fabricPositionName,
        isSpecify: 'N',
        isCustomerProvide: 'N',
      }))
      const codes = this.selectedProducts.map((item) => item.amzSkuSpecCode)

      const confirmResult = await this.$confirm(
        '点击确定后，选中的产品规格原有关联的面料将被删除，使用最新选择的面料进行替换。',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).catch(() => false)

      if (!confirmResult) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzSkuSpecFabricSaveBatchApi({
          codes: codes,
          saves: fabricData,
          isDelete: true,
        })
        .catch(() => null)

      this.loadingClose()

      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close(false)
      this.$emit('reload')
    },
    close(isConfirm) {
      if (this.fabricList.length > 0 && isConfirm) {
        this.$confirm(
          this.$l('INDEX.tips_check_saved') ||
            '如对当前页面内容做过修改，请先保存后再关闭。',
          this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.$emit('update:visible', false)
            this.$emit('close')
          })
          .catch(() => {})
      } else {
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    },
    handleClose(done) {
      if (this.fabricList.length > 0) {
        this.$confirm(
          this.$l('INDEX.tips_check_saved') ||
            '如对当前页面内容做过修改，请先保存后再关闭。',
          this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText:
              this.$l('INDEX.product_dialog_btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => {
            done()
          })
          .catch(() => {})
      } else {
        done()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0;
}
::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding: 0;
}

.drawer-header-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  
  .drawer-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 35px 10px 20px;

    .drawer-title {
      font-size: 14px;
      font-weight: 400;
      color: #303133;
    }
  }

  .drawer-content-container {
    padding: 0 35px 10px 20px;
    height: calc(100vh - 60px);
    overflow-y: auto;

    .section {
      .section-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 12px;
        padding: 10px 0;

        .section-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>

